import { Session } from './sessions/Session';
import { BaseObserver } from '@journeyapps-labs/common-utils';

export interface GeoLocationEngineListener {
  recorded: () => any;
}

export interface GeoLocationEngineOptions {
  session: Session;
}
export class GeoLocationEngine extends BaseObserver<GeoLocationEngineListener> {
  private interval: NodeJS.Timeout;
  private updating: boolean;

  constructor(protected options: GeoLocationEngineOptions) {
    super();
    this.updating = false;
    options.session.registerListener({
      activate: () => {
        this.start();
      },
      deactivate: () => {
        this.stop();
      }
    });
  }

  async getLocation() {
    if (!navigator.geolocation) {
      return null;
    }
    try {
      return await new Promise<GeolocationPosition>((resolve, error) => {
        navigator.geolocation.getCurrentPosition(resolve, error);
      });
    } catch (ex) {}
    return null;
  }

  async recordPosition() {
    if (this.updating) {
      return false;
    }
    this.updating = true;
    let location = await this.getLocation();
    if (!location) {
      this.updating = false;
      return false;
    }
    try {
      await this.options.session.api_client.profile.updateLocation({
        latitude: location.coords.latitude,
        longitude: location.coords.longitude
      });
      this.iterateListeners((cb) => {
        cb.recorded?.();
      });
    } catch (ex) {
      console.error('failed to record position', ex);
    }
    this.updating = false;
  }

  start() {
    if (this.interval) {
      return;
    }
    this.recordPosition();
    this.interval = setInterval(() => {
      this.recordPosition();
    }, 30_000);
  }

  stop() {
    clearInterval(this.interval);
  }
}
